var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.$route.meta.showNavbar)?_c('title-bar'):_vm._e(),(_vm.$route.meta.showNavbar && _vm.isLoading)?_c('loading'):_vm._e(),_c('router-view'),_c('system-lock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }